import React from 'react';
import Layout from './components/Layout';

export default ({ element }: { element: React.ReactNode }) => {
  return <Layout>{element}</Layout>;
};
